import { render, staticRenderFns } from "./onePay.vue?vue&type=template&id=dcee019e&"
import script from "./onePay.vue?vue&type=script&lang=js&"
export * from "./onePay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports